exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-page .table-wrap[data-v-c6eee836] {\n  margin-top: 20px;\n}\n.upload-page .preview-wrap[data-v-c6eee836] {\n  max-height: 600px;\n  overflow-y: auto;\n}\n.upload-page .preview-dom[data-v-c6eee836] {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6eee836","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dragUpload.vue
// module id = 1154
// module chunks = 7